import * as Constants from './constants';

const OWNER_TYPES = Constants.defaultTypeOptions().map((item) => item.value);

// no-dd-sa:javascript-code-style/parameter-name
export const processType = (owner_type, client_name) => {
  if (owner_type === Constants.OWNER_TYPE_CLIENT_STR) {
    return "Client's - " + client_name;
  } else if (OWNER_TYPES.includes(owner_type)) {
    return typeof owner_type != 'undefined' && owner_type !== '' ? "Jitsu's - " + owner_type : 'Jitsu';
  } else if (owner_type === Constants.OWNER_TYPE_COURIER_STR) {
    return `DSP's - ${client_name}`;
  }
};
